/* Better Days Customs - quote form: product repeater + accessible validation */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- product repeater ---------------- */
  function initRepeater(wrap) {
    var max = parseInt(wrap.dataset.max, 10) || 5;
    var addBtn = document.querySelector('[data-bdc-qadd]');
    if (!addBtn) return;

    function items() { return wrap.querySelectorAll('[data-bdc-qitem]'); }

    function renumber() {
      var list = items();
      list.forEach(function (item, i) {
        var n = i + 1;
        item.dataset.index = String(n);
        var num = item.querySelector('[data-bdc-qnum]');
        if (num) num.textContent = String(n);
        item.querySelectorAll('[data-bdc-name]').forEach(function (field) {
          field.name = 'contact[Product ' + n + ' ' + field.dataset.bdcName + ']';
        });
        var rm = item.querySelector('[data-bdc-qremove]');
        if (rm) rm.hidden = list.length < 2;
      });
      addBtn.hidden = list.length >= max;
    }

    function bindRemove(item) {
      var rm = item.querySelector('[data-bdc-qremove]');
      if (!rm) return;
      rm.addEventListener('click', function () {
        var list = items();
        if (list.length < 2) return;
        var idx = Array.prototype.indexOf.call(list, item);
        item.remove();
        renumber();
        var next = items()[Math.min(idx, items().length - 1)];
        var focusTarget = next && next.querySelector('select, input');
        if (focusTarget) focusTarget.focus();
        announce('Product removed. ' + items().length + ' products in this request.');
      });
    }

    addBtn.addEventListener('click', function () {
      var list = items();
      if (list.length >= max) return;
      var clone = list[0].cloneNode(true);
      clone.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (field.tagName === 'SELECT') field.selectedIndex = 0;
        else field.value = '';
        field.removeAttribute('aria-invalid');
      });
      clone.querySelectorAll('.bdc-error').forEach(function (e) { e.remove(); });
      wrap.appendChild(clone);
      bindRemove(clone);
      renumber();
      var first = clone.querySelector('select, input');
      if (first) first.focus();
      announce('Product ' + items().length + ' added.');
    });

    items().forEach(bindRemove);
    renumber();
  }

  /* ---------------- live region ---------------- */
  var liveRegion;
  function announce(msg) {
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.className = 'visually-hidden-bdc';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = msg;
  }

  /* ---------------- validation ---------------- */
  function labelFor(field) {
    if (field.dataset.bdcLabel) return field.dataset.bdcLabel;
    var lab = field.closest('label');
    if (lab) return lab.textContent.replace('*', '').trim().split('\n')[0];
    return 'This field';
  }

  function clearError(field) {
    field.removeAttribute('aria-invalid');
    var described = field.getAttribute('aria-describedby');
    if (described) {
      var el = document.getElementById(described);
      if (el && el.classList.contains('bdc-error')) el.remove();
      field.removeAttribute('aria-describedby');
    }
  }

  function showError(field, message) {
    clearError(field);
    field.setAttribute('aria-invalid', 'true');
    var id = 'bdc-err-' + Math.random().toString(36).slice(2, 9);
    var p = document.createElement('p');
    p.className = 'bdc-error';
    p.id = id;
    p.textContent = message;
    var anchor = field.closest('label') || field.parentNode;
    anchor.appendChild(p);
    field.setAttribute('aria-describedby', id);
  }

  function validateField(field) {
    if (field.type === 'checkbox') {
      if (field.required && !field.checked) {
        showError(field, 'Please confirm this to continue.');
        return false;
      }
      clearError(field);
      return true;
    }
    var value = (field.value || '').trim();
    if (field.required && !value) {
      showError(field, labelFor(field) + ' is required.');
      return false;
    }
    if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      showError(field, 'Enter a valid email address, for example you@company.com.');
      return false;
    }
    if (field.type === 'url' && value && !/^https?:\/\/.+\..+/i.test(value)) {
      showError(field, 'Enter a full link starting with https://');
      return false;
    }
    clearError(field);
    return true;
  }

  function initValidation(form) {
    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('submit', function (e) {
      var fields = form.querySelectorAll('input, select, textarea');
      var firstBad = null;
      var badCount = 0;
      fields.forEach(function (field) {
        if (field.type === 'hidden' || field.closest('.bdc-hp')) return;
        if (!validateField(field)) {
          badCount++;
          if (!firstBad) firstBad = field;
        }
      });
      if (firstBad) {
        e.preventDefault();
        announce(badCount + (badCount === 1 ? ' field needs attention.' : ' fields need attention.'));
        firstBad.focus();
        firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    form.addEventListener('blur', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input, select, textarea')) return;
      if (t.closest('.bdc-hp')) return;
      if (t.hasAttribute('aria-invalid') || (t.required && !t.value)) validateField(t);
    }, true);

    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('aria-invalid')) validateField(t);
    });
  }

  ready(function () {
    var wrap = document.querySelector('[data-bdc-quote-items]');
    if (wrap) initRepeater(wrap);

    document.querySelectorAll('form.bdc-quote-form, form.bdc-contact-form').forEach(initValidation);

    /* carry a product configuration across from the product builder */
    var configForm = document.getElementById('bdc-quote-form');
    if (configForm) {
      var stored = null;
      try { stored = sessionStorage.getItem('bdc:config'); } catch (e) { stored = null; }
      if (stored) {
        try {
          var cfg = JSON.parse(stored);
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'contact[Product configuration]';
          hidden.value = cfg.summary || '';
          configForm.appendChild(hidden);

          var body = configForm.querySelector('textarea[name="contact[body]"]');
          if (body && !body.value) {
            body.value = 'Configured on the product page:\n' + (cfg.summary || '');
          }
          var banner = document.createElement('div');
          banner.className = 'bdc-carry';
          banner.innerHTML = '<strong>Your product selections came across.</strong> ' +
            (cfg.title ? cfg.title + ' is included in this request. ' : '') +
            'Add anything else below.';
          configForm.insertBefore(banner, configForm.firstChild);

          sessionStorage.removeItem('bdc:config');
        } catch (e) { /* ignore malformed state */ }
      }
    }

    var success = document.getElementById('bdc-quote-success') || document.getElementById('bdc-contact-success');
    if (success) {
      success.focus();
      success.scrollIntoView({ block: 'center' });
    }
  });
})();
